import React from "react";
import { StyleSheet, Picker, Platform } from "react-native";

import AppTheme from "../../AppTheme";
import DATA from "./data";

export default function IntervalPicker({
  defaultValue,
  onPickerValueChanged = () => {},
  numberOfOptions = 10,
}) {
  const { PICKER_OPTIONS: options } = DATA;

  return (
    <Picker
      style={styles.picker}
      itemStyle={{ textAlign: "right" }}
      selectedValue={defaultValue}
      onValueChange={(h) => onPickerValueChanged(h)}
    >
      {options.slice(0, numberOfOptions).map((h) => (
        <Picker.Item key={h.id} value={h.timeUnit} label={h.label} />
      ))}
    </Picker>
  );
}

const styles = StyleSheet.create({
  picker: {
    width: 107,
    backgroundColor: "#F4F6FA",
    borderRadius: 4,
    paddingVertical: 3,
    paddingHorizontal: 10,
    borderWidth: 0,
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
});
